import { initActionSlots } from "./actionSlot/actionSlots";
import { initBattleCards } from "./battleCards/battleCards";
import { initCards } from "./card/cards";
import { initPlayerLeaders } from "./constant/playerLeaders";
import { initIntrigueCards } from "./intrigueCards/intrigueCards";

let hasBeenCalled = false;

export const init = () => {
  if (hasBeenCalled) return;
  hasBeenCalled = true;
  initActionSlots();
  initBattleCards();
  initCards();
  initIntrigueCards();
  initPlayerLeaders();
  console.debug("init OK");
};
